<template>
  <tr>
    <slot v-if="areLp" name="Lp">
      <w-lp-cell v-if="isBody" v-bind="fields[prefix + 'Lp']" :index="index" class="rowindex" />

      <td
        v-else
        v-bind="fields[prefix + 'Lp']"
        :colspan="fields[prefix + 'Lp'] && fields[prefix + 'Lp'].colspan ? fields[prefix + 'Lp'].colspan : propertiesCount - flatProperties.length + areLp"
        class="text-right state-disabled text-bold rowindex"
      >
        {{ model.$schema.title }}
      </td>
    </slot>

    <template v-for="(property, propertyIndex) in flatProperties">
      <slot :name="property" :item="model" :property="model[property]" :propertyName="property">
        <w-table-cell v-if="model[property]" :model="model[property]" :key="propertyIndex" v-bind="fields[prefix + property]" />
      </slot>
    </template>

    <slot v-if="areRowBtns" name="RowBtns">
      <w-row-buttons
        v-if="isBody"
        v-bind="fields[prefix + 'RowBtns']"
        :model="model"
        :delete-row="array.$schema.length === undefined && (array.$schema.minItems || 0) < array.$items.length"
      />

      <td v-else v-bind="fields[prefix + 'RowBtns']" class="state-disabled">&nbsp;</td>
    </slot>
  </tr>
</template>

<script>
import tableMixin from '../mixins/tableMixin';

export default {
  name: 'w-tblock',
  mixins: [tableMixin],
  props: {
    propertiesCount: {
      type: Number,
      default: 0
    },
    index: {
      type: Number,
      default: 0
    },
    prefix: {
      type: String,
      default: ''
    }
  },
  computed: {
    array() {
      return this.model.$parent;
    },
    isBody() {
      return this.array ? this.array.$schema.type === 'array' : false;
    }
  }
};
</script>
